var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2TimeoffStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9583 40.9577L19.3854 15.0246C20.809 14.1444 22.2674 13.5018 23.7604 13.0968C25.2535 12.6919 26.816 12.4894 28.4479 12.4894C31.0521 12.4894 33.5087 12.9736 35.8177 13.9419C38.1267 14.9102 40.1493 16.2394 41.8854 17.9296C43.6215 19.6197 44.9931 21.618 46 23.9243C47.0069 26.2306 47.4931 28.7218 47.4583 31.3979C47.4236 33.0528 47.1979 34.6901 46.7812 36.3099C46.3646 37.9296 45.7569 39.4789 44.9583 40.9577ZM48.6042 19.7254L40.0625 11.0106L42.4062 8.9507L51 17.2958L48.6042 19.7254ZM47.9792 53L41.0521 45.9754C39.4896 47.3838 37.6319 48.4842 35.4792 49.2764C33.3264 50.0687 31.0868 50.4648 28.7604 50.4648C26.191 50.4648 23.7778 49.9718 21.5208 48.9859C19.2639 48 17.3021 46.6444 15.6354 44.919C13.9688 43.1937 12.6493 41.169 11.6771 38.8451C10.7049 36.5211 10.2188 34.0211 10.2188 31.3451C10.2188 29.0915 10.5833 26.9613 11.3125 24.9542C12.0417 22.9472 13.1701 20.993 14.6979 19.0915L11.9896 16.3451L8.91667 19.4613L6.57292 17.0845L9.64583 13.9683L6 10.2711L8.23958 8L50.2188 50.7289L47.9792 53Z",
    fill: "#6b7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2TimeoffStandard);
export default __webpack_public_path__ + "static/media/v2-timeoff-standard.88b8905dac72b301e1b4c9315a308aa6.svg";
export { ForwardRef as ReactComponent };